import { NLUserMailState } from "@models/Models";
import { NLUserMailStateNames } from "@models/Enums";

export const isVisibleFeedSender = (state: NLUserMailState): boolean => {
	return state.state_id === NLUserMailStateNames.feed && !state.is_hidden_from_senders;
};

export const isHiddenFeedSender = (state: NLUserMailState): boolean => {
	return state.state_id === NLUserMailStateNames.feed && state.is_hidden_from_senders;
};
